import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionIdService } from './session-id.service';

/**
 * Agrega el x-session-id estable de la sesion a cada request del frontend.
 * Convive con el traceability-id por request del AuthenticationInterceptor:
 * traceability-id correlaciona UN request punta a punta; x-session-id agrupa
 * todos los requests de la sesion del usuario.
 *
 * NO se envia traceparent desde el browser: el frontend no exporta spans y
 * generaria traces sin raiz en Tempo.
 */
@Injectable()
export class SessionIdInterceptor implements HttpInterceptor {
  readonly #sessionId: SessionIdService;

  constructor(sessionId: SessionIdService) {
    this.#sessionId = sessionId;
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(
      request.clone({
        setHeaders: { 'x-session-id': this.#sessionId.getSessionId() },
      })
    );
  }
}
